import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CloseCardButton = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fill="#BAE0FF"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.66675 14C11.5327 14 14.6667 10.866 14.6667 7C14.6667 3.13401 11.5327 0 7.66675 0C3.80075 0 0.666748 3.13401 0.666748 7C0.666748 10.866 3.80075 14 7.66675 14ZM6.19708 4.46967C5.90418 4.17678 5.42931 4.17678 5.13642 4.46967C4.84352 4.76256 4.84352 5.23744 5.13642 5.53033L6.60609 7L5.13642 8.46967C4.84352 8.76256 4.84352 9.23744 5.13642 9.53033C5.42931 9.82322 5.90418 9.82322 6.19708 9.53033L7.66675 8.06066L9.13642 9.53033C9.42931 9.82322 9.90418 9.82322 10.1971 9.53033C10.49 9.23744 10.49 8.76256 10.1971 8.46967L8.72741 7L10.1971 5.53033C10.49 5.23744 10.49 4.76256 10.1971 4.46967C9.90418 4.17678 9.42931 4.17678 9.13642 4.46967L7.66675 5.93934L6.19708 4.46967Z"
        />
      </svg>
    );
  },
);
